import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const api = {
  // Materials
  getMaterials: async () => {
    const response = await axios.get(`${API}/materials`);
    return response.data;
  },

  // Printers
  getPrinters: async () => {
    const response = await axios.get(`${API}/printers`);
    return response.data;
  },

  // Filename parsing
  parseFilename: async (filename) => {
    const response = await axios.post(`${API}/parse/filename`, { filename });
    return response.data;
  },

  // Weight estimation
  estimateWeight: async (data) => {
    const response = await axios.post(`${API}/estimate/weight`, data);
    return response.data;
  },

  // Time estimation
  estimateTime: async (data) => {
    const response = await axios.post(`${API}/estimate/time`, data);
    return response.data;
  },

  // COGS calculation
  calculateCOGS: async (data) => {
    const response = await axios.post(`${API}/cogs`, data);
    return response.data;
  },

  // Presets
  getPresets: async (type = null) => {
    const url = type ? `${API}/presets?preset_type=${type}` : `${API}/presets`;
    const response = await axios.get(url);
    return response.data;
  },

  createPreset: async (preset) => {
    const response = await axios.post(`${API}/presets`, preset);
    return response.data;
  },

  deletePreset: async (presetId) => {
    const response = await axios.delete(`${API}/presets/${presetId}`);
    return response.data;
  }
};
